import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageFallback } from "@/components/layout/PageFallback";

// "/" é a porta de entrada: todo mundo cai direto dentro do app. Assinante vai pro dashboard
// dele, quem tem conta mas ainda não assinou vai pra tela de pagamento, e o visitante sem conta
// vê o dashboard em modo demonstração. A página de venda antiga continua em /sobre.
export function Home() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <PageFallback />;

  if (user) {
    return <Navigate to={user.isPremium ? "/dashboard" : "/premium"} replace />;
  }

  // Mantém a query string: é nela que vem o fbclid/utm do anúncio, que o pixel do Meta ainda
  // precisa ler pra ligar essa visita ao clique.
  return <Navigate to={{ pathname: "/dashboard", search: location.search, hash: location.hash }} replace />;
}
